/**
 * Molecule Assessment — LoopRX API (create-assessment + images)
 */
(function (global) {
  'use strict';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function buildAssessmentPayload(state, config) {
    var a = state.answers || {};
    var ethnicity = a.Ethnicity || a.ethnicity || '';
    var ethnicityOther = (a.Ethnicity_other || a.ethnicity_other || '').trim();
    if (ethnicity === 'other' && ethnicityOther) {
      ethnicity = 'Other - ' + ethnicityOther;
    }

    function mergeOtherIntoList(raw, otherText) {
      var list = raw || [];
      if (!Array.isArray(list)) list = list ? [list] : [];
      var other = (otherText || '').trim();
      return list.map(function (value) {
        if (value === 'other' && other) {
          return 'Other - ' + other;
        }
        return value;
      });
    }

    function asStringValue(list) {
      if (!list || !list.length) return '';
      if (list.length === 1) return list[0];
      return list.join(', ');
    }

    var reasonsRaw = a.weight_loss_reasons || a.reasons || [];
    if (!Array.isArray(reasonsRaw)) reasonsRaw = reasonsRaw ? [reasonsRaw] : [];
    var reasonsOther = (a.weight_loss_reasons_other || a.reasons_other || '').trim();
    var weightLossReasons = asStringValue(
      reasonsRaw.map(function (value) {
        if (value === 'other' && reasonsOther) {
          return 'Other - ' + reasonsOther;
        }
        return value;
      })
    );

    var medicalConditions = asStringValue(
      mergeOtherIntoList(a.medical_conditions, a.medical_conditions_other)
    );
    var otherMedicalConditions = asStringValue(
      mergeOtherIntoList(a.other_medical_conditions, a.other_medical_conditions_other)
    );
    var previousWeightLossMethods = asStringValue(
      mergeOtherIntoList(
        a.previous_weight_loss_methods,
        a.previous_weight_loss_methods_other
      )
    );

    var diagnosedEatingDisorder = a.diagnosed_eating_disorder || '';
    var eatingDisorderOther = (a.diagnosed_eating_disorder_other || '').trim();
    if (
      (diagnosedEatingDisorder === 'yes' || diagnosedEatingDisorder === 'unsure') &&
      eatingDisorderOther
    ) {
      diagnosedEatingDisorder =
        (diagnosedEatingDisorder === 'yes' ? 'Yes' : 'Unsure') + ' - ' + eatingDisorderOther;
    }

    var allergies = a.allergies || '';
    var allergiesOther = (a.allergies_other || '').trim();
    if (allergies === 'yes' && allergiesOther) {
      allergies = 'Yes - ' + allergiesOther;
    }

    var contraceptionMethod =
      a.contraception_method || a.current_contraception || '';
    var contraceptionOther = (
      a.contraception_method_other ||
      a.current_contraception_other ||
      ''
    ).trim();
    if (contraceptionMethod === 'other' && contraceptionOther) {
      contraceptionMethod = 'Other - ' + contraceptionOther;
    }
    var oralContraceptive = a.currently_taking_contraceptive || '';
    if (!oralContraceptive) {
      oralContraceptive =
        a.contraception_method === 'combined-pill' ||
        a.contraception_method === 'progestogen-only-pill' ||
        a.current_contraception === 'combined-pill' ||
        a.current_contraception === 'progestogen-only-pill'
          ? 'yes'
          : a.contraception_method || a.current_contraception
            ? 'no'
            : '';
    }

    var sideEffects =
      a.previous_treatment_side_effects || a.experienced_side_effects || '';
    var sideEffectsOther = (
      a.previous_treatment_side_effects_other ||
      a.experienced_side_effects_other ||
      ''
    ).trim();
    if (sideEffects === 'yes' && sideEffectsOther) {
      sideEffects = 'Yes - ' + sideEffectsOther;
    }

    var stopReason =
      a.stopped_treatment_reason || a.why_stopped_treatment || '';
    var stopReasonOther = (
      a.stopped_treatment_reason_other ||
      a.why_stopped_treatment_other ||
      ''
    ).trim();
    if (stopReason === 'other' && stopReasonOther) {
      stopReason = 'Other - ' + stopReasonOther;
    }

    var diabetesMedicines = asStringValue(
      mergeOtherIntoList(a.diabetes_medicines, a.diabetes_medicines_other)
    );

    var otherOrRecentMedicines = a.other_or_recent_medicines || '';
    var otherOrRecentMedicinesOther = (a.other_or_recent_medicines_other || '').trim();
    if (otherOrRecentMedicines === 'yes' && otherOrRecentMedicinesOther) {
      otherOrRecentMedicines = 'Yes - ' + otherOrRecentMedicinesOther;
    }

    return {
      form_type: (config.api && config.api.formType) || 'webmed',
      category_id: Number((config.api && config.api.categoryId) || 1) || 1,
      email: a.email || '',
      first_name: a.first_name || '',
      last_name: a.last_name || '',
      phone: a.phone || '',
      weight_loss_reasons: weightLossReasons,
      previous_weight_loss_methods: previousWeightLossMethods,
      date_of_birth: [a.dob_yyyy, a.dob_mm, a.dob_dd].filter(Boolean).join('-'),
      height_cm: a.height_cm || '',
      weight_kg: a.weight_kg || '',
      weight_last_checked: a.weight_last_checked || '',
      Ethnicity: ethnicity,
      gender: a.gender || a.sex || '',
      able_to_become_pregnant: a.able_to_become_pregnant || '',
      /* LoopRX Q7 maps to pregnant (not currently_pregnant) */
      pregnant: a.currently_pregnant || a.pregnant || '',
      currently_taking_oral_hrt: a.currently_taking_oral_hrt || '',
      currently_taking_contraceptive: oralContraceptive,
      /* LoopRX Q22 maps to current_contraception (not contraception_method) */
      current_contraception: contraceptionMethod,
      /* LoopRX Q10 maps to weight_loss (not medications_to_aid_in_weight_loss) */
      weight_loss: a.medications_to_aid_in_weight_loss || a.weight_loss || '',
      last_dose_strength: a.last_dose_strength || '',
      last_dose_date:
        a.last_dose_date ||
        [a.rx_yyyy, a.rx_mm, a.rx_dd].filter(Boolean).join('-'),
      /* LoopRX Q23 maps to weight_lost_on_treatment (not weight_lost_kg) */
      weight_lost_on_treatment: (function () {
        var status = (a.weight_lost_status || '').trim();
        if (status === 'none' || status === 'unsure') return status;
        return a.weight_lost_on_treatment || a.weight_lost_kg || '';
      })(),
      /* LoopRX Q24 maps to why_stopped_treatment (not stopped_treatment_reason) */
      why_stopped_treatment: stopReason,
      /* LoopRX Q25 maps to experienced_side_effects (not previous_treatment_side_effects) */
      experienced_side_effects: sideEffects,
      restart_lowest_dose: !!a._restart_lowest_dose,
      /* LoopRX Q13 maps to any_of_the_following_statements_1 (not medical_conditions) */
      any_of_the_following_statements_1: medicalConditions,
      other_medical_conditions: otherMedicalConditions,
      mental_health_condition: a.mental_health_condition || '',
      diabetes_medicines: diabetesMedicines,
      due_for_operation_or_sedation: a.due_for_operation_or_sedation || '',
      other_or_recent_medicines: otherOrRecentMedicines,
      allergies: allergies,
      diagnosed_eating_disorder: diagnosedEatingDisorder,
      identity_document_type: a.identity_document_type || a.id_document_type || '',
      treatment_safety_ack: !!a.treatment_safety_ack,
      pre_submit_ack: !!a.pre_submit_ack,
      foundayo_contraception_ack: !!a.foundayo_contraception_ack,
      patient_info_ack: !!a.patient_info_ack,
      metformin_ack: !!a.metformin_ack,
      levothyroxine_ack: !!a.levothyroxine_ack,
      antihypertensive_ack: !!a.antihypertensive_ack,
      warfarin_ack: !!a.warfarin_ack,
      gp_name: (a.gp_name || '').trim(),
      gp_address: [a.gp_address, a.gp_postcode]
        .map(function (v) {
          return (v || '').trim();
        })
        .filter(Boolean)
        .join(', '),
      confirm_accurate: !!a.confirm_accurate
    };
  }

  function buildFormData(state, config) {
    var a = state.answers || {};
    var api = (config && config.api) || {};
    var fd = new FormData();
    fd.append('patient_email', a.email || '');
    fd.append('First-Name', a.first_name || '');
    fd.append('Last-Name', a.last_name || '');
    fd.append('Phone', a.phone || '');
    fd.append('category_id', String(Number(api.categoryId) || 1));
    fd.append('assessment', JSON.stringify(buildAssessmentPayload(state, config)));
    return fd;
  }

  function postCreateAssessment(state, config) {
    var api = config.api || {};
    var url = api.url || 'https://demo-app-config.looprx.io/api/create-assessment';
    var headers = {
      Accept: 'application/json',
      'X-Tenant': api.tenant || 'webmed'
    };
    var token = getCookie(api.authCookie || 'access_token');
    if (token) headers.Authorization = 'Bearer ' + token;

    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: buildFormData(state, config),
      credentials: 'include'
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = {};
        if (text && text.trim()) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            body = { message: text };
          }
        }
        return { ok: res.ok, status: res.status, body: body };
      });
    });
  }

  var UPLOAD_SLOT_KEYS = ['fullbody', 'identity', 'prescription'];

  var UPLOAD_API_KEYS = {
    fullbody: 'full_body',
    identity: 'photo_id',
    prescription: 'last_product'
  };

  function buildImagesPayload(state, config) {
    var uploads = state.uploads || {};
    var api = (config && config.api) || {};
    var payload = {
      patient_email: (state.answers && state.answers.email) || '',
      category_id: Number(api.categoryId) || 1
    };

    UPLOAD_SLOT_KEYS.forEach(function (slot) {
      var item = uploads[slot];
      if (item && item.cdnUrl) {
        payload[UPLOAD_API_KEYS[slot] || slot] = item.cdnUrl;
      }
    });

    return payload;
  }

  function uploadAssessmentImages(state, config) {
    var api = config.api || {};
    var url =
      api.imagesUrl || 'https://demo-app-config.looprx.io/api/upload-assessment-images-v3';
    var payload = buildImagesPayload(state, config);

    if (!payload.full_body && !payload.photo_id && !payload.last_product) {
      return Promise.resolve({ skipped: true });
    }

    var headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Tenant': api.tenant || 'webmed'
    };
    var token = getCookie(api.authCookie || 'access_token');
    if (token) headers.Authorization = 'Bearer ' + token;

    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      credentials: 'include'
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = {};
        if (text && text.trim()) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            body = { message: text };
          }
        }
        if (!res.ok) {
          var msg =
            (body.errors && body.errors.images && body.errors.images[0]) ||
            body.message ||
            'Image upload failed (' + res.status + ')';
          throw new Error(msg);
        }
        return body;
      });
    });
  }

  function buildSelectProductUrl(config, state) {
    var base = (config && config.successRedirectUrl) || '/pages/select-product';
    var url;
    try {
      url = new URL(base, window.location.origin);
    } catch (e) {
      url = new URL('/pages/select-product', window.location.origin);
    }
    var a = state.answers || {};
    if (a.email) url.searchParams.set('email', a.email);
    if (a.first_name) url.searchParams.set('first_name', a.first_name);
    if (a.last_name) url.searchParams.set('last_name', a.last_name);
    if (a.phone) url.searchParams.set('phone', String(a.phone).trim());
    var med = a.medications_to_aid_in_weight_loss;
    if (med && med !== 'none') {
      url.searchParams.set('lastproduct', med);
      if (a.last_dose_strength) url.searchParams.set('lastdose', a.last_dose_strength);
    }
    if (a._restart_lowest_dose) {
      url.searchParams.set('restart', '1');
    }
    /* Figma annotation on Q11b: decline Foundayo contraception ack → exclude Foundayo only */
    if (
      a.able_to_become_pregnant &&
      ['yes', 'unsure', 'prefer-not-to-say'].indexOf(a.able_to_become_pregnant) !== -1 &&
      !a.foundayo_contraception_ack
    ) {
      url.searchParams.set('exclude_foundayo', '1');
    }
    return url.pathname + url.search;
  }

  function submitAssessment(state, config) {
    return postCreateAssessment(state, config).then(function (result) {
      var body = (result && result.body) || {};
      var failed =
        !result.ok ||
        body.success === false ||
        body.status === 'error' ||
        (body.error && body.error.success === false);

      if (failed) {
        var msg =
          (body.error && body.error.message) ||
          body.message ||
          'Unable to submit assessment. Please try again.';
        throw new Error(msg);
      }

      try {
        localStorage.setItem(
          (config.storageKey || 'webmed_wl_assessment') + '_result',
          JSON.stringify(body)
        );
      } catch (e) {}

      var hasImages = UPLOAD_SLOT_KEYS.some(function (k) {
        return state.uploads && state.uploads[k] && state.uploads[k].cdnUrl;
      });

      if (!hasImages) return { ok: true };
      return uploadAssessmentImages(state, config).catch(function (err) {
        console.warn('[wm-assessment] images upload failed after create-assessment', err);
        return { ok: true, imageError: err && err.message };
      });
    });
  }

  global.WmAssessmentApi = {
    buildAssessmentPayload: buildAssessmentPayload,
    submitAssessment: submitAssessment,
    buildSelectProductUrl: buildSelectProductUrl,
    getCookie: getCookie
  };
})(window);
